// extracted by mini-css-extract-plugin
export default {"Category":"Catagory_Category__XTmU3","category__container":"Catagory_category__container__9ztY2"};